import React from 'react';
import QuestionDependency from '../QuestionDependency';
import HtmlComponent from '../../lessonPlayer/components/HtmlComponent';

const AlchemieQuestion = ({ model, isManuscriptShort }) => {
  console.log('AlchemieQuestion model:', model);
  return (
    <div className='element-container' id={`_${model.id}`}>
      <div className='label-value-row'>
        <div>Activity Type:</div>
        <div>Alchemie Activity</div>
      </div>
      <div className='label-value-row'>
        <div className='text-area-label'>Directions:</div>
        <div className='ckeditor-text text-area'><HtmlComponent htmlStr={model.directions} /></div>
      </div>
      <div className='label-value-row'>
        <div>Alchemie URL:</div>
        <div>{model.alchemieUrl || ''}</div>
      </div>
      <div className='label-value-row'>
        <div>Start Code:</div>
        <div>{model.startCode || ''}</div>
      </div>
      {model.config && (
        <div className='label-value-row'>
          <div>Config:</div>
          <div>{model.config}</div>
        </div>
      )}
      {/* advanced options */}
      {!isManuscriptShort && (
        <>
          <QuestionDependency model={model} />
          <div className='label-value-row'>
            <div>Extra Class:</div>
            <div>{model.extraClass}</div>
          </div>
          <div className='label-value-row'>
            <div>Show All Items At Once:</div>
            <div>{(model.showAllChildren) ? 'ON' : 'OFF'}</div>
          </div>
        </>
      )}
    </div>
  );
};

export default AlchemieQuestion;

